const baseUrl = '/api-sornthai';

const getSubPath = () => {
  const phaseStr = localStorage.getItem('phase');
  const phase = phaseStr ? JSON.parse(phaseStr) : null;
  return phase !== 'p2' ? `/${phase}` : '';
};

const fetchJson = async (url: string, options = {}) => {
  const response = await fetch(url, options);
  return await response.json();
};

const fetchBlob = async (url: string, options = {}) => {
  const response = await fetch(url, options);
  return await response.blob();
};

const buildQuery = (params: any) => {
  const searchParams = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    searchParams.set(key, String(value));
  });
  return searchParams.toString();
};

export type ReportDateFilter = {
  gte?: string;
  lte?: string;
};

const buildEducationReportQuery = (
  educationids: any,
  dateFilter?: ReportDateFilter,
  extra?: Record<string, any>,
) =>
  buildQuery({
    educationids,
    ...dateFilter,
    ...extra,
  });

export const postLoginService = async (body: any) =>
  fetchJson(`${baseUrl}/login?type=web`, {
    method: 'POST',
    body: JSON.stringify(body),
  });

export const postLoginInternalService = async (token: any) =>
  fetchJson(`${baseUrl}/login-internal`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
  });

export const postRegisterService = async (body: any) =>
  fetchJson(`${baseUrl}/register`, {
    method: 'POST',
    body: JSON.stringify(body),
  });

export const getEducationsService = async () =>
  fetchJson(`${baseUrl}/educations`);

export const getEducationsByTeacherService = async (queryParams: any) =>
  fetchJson(`${baseUrl}/educations-by-teacher?${buildQuery(queryParams)}`);

export const getSchoolsService = async () => fetchJson(`${baseUrl}/schools`);

export const getRolesService = async () => fetchJson(`${baseUrl}/roles`);

// dashboard export
export const getStageAverageScoreService = async (
  educationids: any,
  dateFilter?: ReportDateFilter,
) =>
  fetchJson(
    `${baseUrl}${getSubPath()}/stage-average-score?${buildEducationReportQuery(
      educationids,
      dateFilter,
    )}`,
  );

export const getClearPctStageService = async (
  educationids: any,
  dateFilter?: ReportDateFilter,
) =>
  fetchJson(
    `${baseUrl}${getSubPath()}/clear-pct-stage?${buildEducationReportQuery(
      educationids,
      dateFilter,
    )}`,
  );

export const getClearPctVowelService = async (
  educationids: any,
  dateFilter?: ReportDateFilter,
) => {
  const path = getSubPath();
  const choiceids = path
    ? Array.from(
        { length: 28 },
        (_, i) => `cp2_${(i + 1).toString().padStart(3, '0')}`,
      ).join(',')
    : '';
  return fetchJson(
    `${baseUrl}${getSubPath()}/clear-pct-vowel?${buildEducationReportQuery(
      educationids,
      dateFilter,
      { choiceids },
    )}`,
  );
};

export const getUserDataStagesService = async (id: string) =>
  fetchJson(`${baseUrl}${getSubPath()}/stage-data-student/${id}`);

export const getStageDataAnalysisService = async (queryParams: any) =>
  fetchJson(
    `${baseUrl}${getSubPath()}/stage-data-analysis?${buildQuery(queryParams)}`,
  );
// end dashboard export

export const getUserListService = async (queryParams: any) =>
  fetchJson(`${baseUrl}/user-list?${buildQuery(queryParams)}`);

export const getRawDataService = async (
  userids: any,
  educationids: any,
  dateFilter?: ReportDateFilter,
) =>
  fetchBlob(
    `${baseUrl}${getSubPath()}/v2/raw-data?${buildEducationReportQuery(
      educationids,
      dateFilter,
      { userids },
    )}`,
  );

export const getStageDataStudentsService = async (queryParams: any) =>
  fetchJson(
    `${baseUrl}${getSubPath()}/stage-data-students?${buildQuery(queryParams)}`,
  );

export const getGroupsService = async () => fetchJson(`${baseUrl}/groups`);

export const postGroupService = async (body: any) =>
  fetchJson(`${baseUrl}/group`, {
    method: 'POST',
    body: JSON.stringify(body),
  });

export const patchGroupService = async (id: string, body: any) =>
  fetchJson(`${baseUrl}/group/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });

export const deleteGroupService = async (id: string) =>
  fetchJson(`${baseUrl}/group/${id}`, {
    method: 'DELETE',
  });

export const deleteStudentsService = async (body: any) =>
  fetchJson(`${baseUrl}/students`, {
    method: 'DELETE',
    body: JSON.stringify(body),
  });

export const getStageScoresService = async (queryParams: any) =>
  fetchJson(`${baseUrl}/stage-scores?${buildQuery(queryParams)}`);

export const getMembersService = async (queryParams: any) =>
  fetchJson(
    `${baseUrl}/members?${buildQuery({
      phase: JSON.parse(localStorage.getItem('phase') || 'null'),
      ...queryParams,
    })}`,
  );

export const getStageDataChildrenService = async (userid: string) =>
  fetchJson(`${baseUrl}${getSubPath()}/stage-data-children/${userid}`);

export const getUsersService = async (queryParams: any) =>
  fetchJson(`${baseUrl}/users?${buildQuery(queryParams)}`);

export const getUsersSearchService = async (queryParams: any) =>
  fetchJson(`${baseUrl}/users/search?${buildQuery(queryParams)}`);

export const getUserService = async (userid: string) =>
  fetchJson(`${baseUrl}/users/${userid}`);

export const getUserByMeService = async () => fetchJson(`${baseUrl}/userByMe`);

export const patchUserService = async (userid: string, body: any) =>
  fetchJson(`${baseUrl}/users/${userid}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });

export const resetPasswordService = async (password: string, token: string) =>
  fetchJson(`${baseUrl}/reset-password`, {
    method: 'POST',
    body: JSON.stringify({ password }),
    headers: { Authorization: `Bearer ${token}` },
  });
